"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    caption1ClassNames: ()=>caption1ClassNames,
    Caption1: ()=>Caption1
});
const _react = require("@griffel/react");
const _createPreset = require("../createPreset");
const caption1ClassNames = {
    root: 'fui-Caption1'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react["__styles"])({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "fy9rknc",
        Bhrd7zp: "figsok6",
        Bg96gwp: "fwrc4pm"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".fy9rknc{font-size:var(--fontSizeBase200);}",
        ".figsok6{font-weight:var(--fontWeightRegular);}",
        ".fwrc4pm{line-height:var(--lineHeightBase200);}"
    ]
});
const Caption1 = /*#__PURE__*/ (0, _createPreset.createPreset)({
    useStyles,
    className: caption1ClassNames.root,
    displayName: 'Caption1'
}); //# sourceMappingURL=Caption1.js.map

//# sourceMappingURL=Caption1.js.map